import { z } from "zod";

export const photoFollowupStatusSchema = z.enum([
	"scheduled",
	"reminded",
	"completed",
	"cancelled",
]);
export type PhotoFollowupStatus = z.infer<typeof photoFollowupStatusSchema>;

export const photoFollowupApiSchema = z.object({
	id: z.string().uuid(),
	clinic_id: z.string().uuid(),
	patient_id: z.string().uuid(),
	patient_name: z.string().nullable(),
	patient_phone: z.string().nullable(),
	visit_id: z.string().uuid().nullable(),
	due_date: z.string(),
	area: z.string().nullable(),
	note: z.string().nullable(),
	status: photoFollowupStatusSchema,
	channel: z.string(),
	reminded_at: z.string().datetime().nullable(),
	completed_at: z.string().datetime().nullable(),
	created_by_member_id: z.string().uuid().nullable(),
	created_at: z.string().datetime(),
	updated_at: z.string().datetime(),
});
export type PhotoFollowupApi = z.infer<typeof photoFollowupApiSchema>;

export const createPhotoFollowupInputSchema = z.object({
	patient_id: z.string().uuid(),
	visit_id: z.string().uuid().optional(),
	/** Either an explicit due date (YYYY-MM-DD) or days-from-now. */
	due_date: z.string().optional(),
	days_from_now: z.number().int().positive().max(365).optional(),
	area: z.string().max(160).optional(),
	note: z.string().max(500).optional(),
	channel: z.string().max(20).optional(),
});
export type CreatePhotoFollowupInput = z.infer<
	typeof createPhotoFollowupInputSchema
>;

export const updatePhotoFollowupInputSchema = z.object({
	status: photoFollowupStatusSchema.optional(),
	due_date: z.string().optional(),
	area: z.string().max(160).nullable().optional(),
	note: z.string().max(500).nullable().optional(),
});
export type UpdatePhotoFollowupInput = z.infer<
	typeof updatePhotoFollowupInputSchema
>;
